// Defensive guard: some schools have generic/shared Joomla logins that are
// not real staff (e.g. "SCHOOL ADMINISTRATOR", "SUPER USER"). These should
// never be selectable as a ticket assignee, even if one of them ever shows
// up in a school's staff data.

const GENERIC_LOGIN_NAMES = ["SCHOOL ADMINISTRATOR", "SUPER USER"];

function fullName(staff) {
  return [staff.first_name, staff.middle_name, staff.last_name]
    .filter(Boolean)
    .join(" ")
    .trim()
    .toUpperCase();
}

// Checks a plain display-name string (e.g. from AUserInfo) against known
// generic login names. Staff ids are NOT guaranteed unique across schools —
// a generic login's fixed id can coincidentally collide with a real staff
// member's id at some other school — so name is the reliable signal here.
export function isGenericAccountName(name) {
  return GENERIC_LOGIN_NAMES.indexOf(String(name || "").trim().toUpperCase()) !== -1;
}

export function isGenericStaffLogin(staff) {
  return isGenericAccountName(fullName(staff));
}

export function filterGenericStaff(staffList) {
  if (!Array.isArray(staffList)) return staffList;
  return staffList.filter(function (s) { return !isGenericStaffLogin(s); });
}
